import type { ReactFlowInstance } from "@xyflow/react";

export interface KgViewportFocusOptions {
  padding: number;
  duration: number;
  maxZoom: number;
}

/**
 * Smoothly centers the viewport on one or more nodes.
 */
export const focusViewportOnNodes = (
  reactFlow: ReactFlowInstance,
  nodeIds: string[],
  { padding, duration, maxZoom }: KgViewportFocusOptions,
): void => {
  if (nodeIds.length === 0) return;

  void reactFlow.fitView({
    nodes: nodeIds.map((id) => ({ id })),
    padding,
    duration,
    maxZoom,
  });
};
